import { Check } from "@mui/icons-material";

export interface PermissionsViewProps {
  permissions: Permission[];
}

export default function PermissionsView(props: PermissionsViewProps) {
  return (
    <div className="flex flex-col gap-6">
      {props.permissions.map((section, i, a) => {
        return (
          <div key={i} className={`${i !== a.length - 1 ? "border-b" : ""} flex flex-col gap-4`}>
            {section.columns.map((col, i) => {
              return (
                <div key={i} className="flex items-start gap-4">
                  <div className="text-xs font-bold min-w-[80px] w-20 py-1">{col.title}</div>
                  <div className="flex flex-wrap gap-x-8">
                    {col.permission_data.map((permission, i) => (
                      <div key={i} className="flex items-center gap-1 whitespace-nowrap">
                        <Check color="primary" style={{ transform: "scale(0.7)" }} />
                        <span className="text-xs text-dark-3">{permission.fa_title}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
